import { render, staticRenderFns } from "./shareDetail.vue?vue&type=template&id=8d5e2352&scoped=true"
import script from "./shareDetail.vue?vue&type=script&lang=js"
export * from "./shareDetail.vue?vue&type=script&lang=js"
import style0 from "./shareDetail.vue?vue&type=style&index=0&id=8d5e2352&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5e2352",
  null
  
)

export default component.exports